<template>
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <!-- <van-nav-bar v-show="!isNative"
      title="申请记录"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    >
    </van-nav-bar> -->
    <!-- <ul class="label-list">
      <li v-for="item in liList" :key="item.index" @click="addClass(item.key)" >{{item.title}}</li>
    </ul> -->
    <van-tabs
      swipeable
      title-active-color="#2E3133"
      title-inactive-color="#989DA3"
      @click="addClass"
      type="line"
      line-width="0px"
    >
      <van-tab
        v-for="item in liList"
        :key="item.index"
        :title="item.title"
        border-bottom="false"
      >
        <ul class="job-list">
          <li v-for="item in jobList" :key="item.index" @click="jobDetail(item.id)">
            <div class="detail-top">
              <div v-if="item.sendResumeStatus === 1">
                <span class="text-blue">已查看</span>
              </div>
              <div
                v-if="
                  item.sendResumeStatus === 2 || item.sendResumeStatus === 4
                "
              >
                <span class="text-green">感兴趣</span>
              </div>
              <div v-if="item.sendResumeStatus === 3">
                <span class="text-org">不合适</span>
              </div>
              <div v-if="item.sendResumeStatus === 5">
                <span>邀面试</span>
              </div>
              <div v-if="item.sendResumeStatus === 0">
                <span class="text-org">已投递</span>
              </div>
              <div class="btn-top-cont">
                <div class="time">{{ item.createTime }}</div>
              </div>
            </div>
            <div class="detail-info">
              <div class="info-header">
                <h3>
                  {{ item.jobName }} <small v-if="item.urgent == 1">急</small>
                </h3>
                <span>{{ item.salary }}</span>
              </div>
              <ul class="conditionList">
                <li>
                  {{ item.expLevel }}
                </li>
                <li>
                  {{ item.eduLevel }}
                </li>
              </ul>
              <div class="detail-footer">
                <span>{{ item.enterpriseName }}</span>
                <!-- {{item.createTime.substring(0,item.createTime.length -8)}} -->
                <span>申请日期：{{ item.createTime }}</span>
              </div>
            </div>
          </li>
        </ul>
      </van-tab>
    </van-tabs>
  </van-list>
</template>

<script>
import native from '@utils/native'

export default {
  name: "applicationRecord",
  data() {
    return {
      isNative: native.shmedia2.isRmtNative() !== 0,
      jobList: [],
      list: [],
      loading: false,
      finished: false,
      status: "",
      applyTime: [],
      value: {
        current: 1,
        size: 10
      },
      showBtn: true,
      rejected: false,
      current: 1,
      liList: [
        { title: "全部", key: "" },
        { title: "已查看", key: 1 },
        { title: "感兴趣", key: 2 },
        { title: "邀面试", key: 5 },
        { title: "不合适", key: 3 }
      ]
    };
  },
  // mounted(){
  //    this.$nextTick(() => {
  //      this.onList(this.value)
  //    })
  // },
  methods: {
    onLoad() {
      console.log(this.isNative)
      this.module.api.memberList({
        params: this.value,
        success: res => {
          res.records.forEach(async item => {
            if (item && item.createTime) {
              item.createTime = await this.showTimePipe(item.createTime);
              if (item.createTime.length == 5) {
                item.createTime = "今天";
              } else {
                item.createTime = item.createTime.substring(
                  0,
                  item.createTime.length - 5
                );
              }
              console.log(item.createTime, "applyTime");
            }
          });
          this.jobList = this.jobList.concat(res.records);
          res.pages > this.current && this.current++;
          this.loading = false;
          this.value.current++;
          if (this.jobList.length >= res.total) {
            this.finished = true;
          }
        },
        error: () => {
          this.finished = true
        }
      });
    },
    //  onList(value) {

    //   },
    showTimePipe(unix_stamp) {
      if (!unix_stamp) {
        return "";
      }
      unix_stamp = Date.parse(unix_stamp.replace(/-/g, "/"));
      if (!unix_stamp) {
        return "";
      }
      // unix_stamp 精确到微秒
      var _today_obj = new Date(),
        _today_date = {
          y: _today_obj.getFullYear(),
          m:
            _today_obj.getMonth() + 1 < 10
              ? "0" + (_today_obj.getMonth() - -1)
              : _today_obj.getMonth() - -1,
          d:
            _today_obj.getDate() < 10
              ? "0" + _today_obj.getDate()
              : _today_obj.getDate()
        };
      var _today_stamp = Date.parse(
        _today_date.y + "/" + _today_date.m + "/" + _today_date.d + " 00:00:00"
      );
      var stamp = [];
      stamp[0] = _today_stamp + 86400000;
      stamp[1] = _today_stamp;
      stamp[2] = _today_stamp - 86400000;
      stamp[3] = _today_stamp - 172800000;

      stamp[4] = _today_stamp - 518400000; // 7天

      stamp[5] = _today_stamp - 31536000000; // 365天

      var _compare_obj = new Date();
      _compare_obj.setTime(unix_stamp);

      var return_str;

      if (unix_stamp >= stamp[1] && unix_stamp < stamp[0]) {
        return_str =
          _compare_obj.getHours() +
          ":" +
          (_compare_obj.getMinutes() < 10
            ? "0" + _compare_obj.getMinutes()
            : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[2] && unix_stamp < stamp[1]) {
        var yesterdayText = "昨天";
        return_str =
          yesterdayText +
          " " +
          _compare_obj.getHours() +
          ":" +
          (_compare_obj.getMinutes() < 10
            ? "0" + _compare_obj.getMinutes()
            : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[3] && unix_stamp < stamp[2]) {
        var theDayBeforeYesterdayText = "前天";
        return_str =
          theDayBeforeYesterdayText +
          " " +
          _compare_obj.getHours() +
          ":" +
          (_compare_obj.getMinutes() < 10
            ? "0" + _compare_obj.getMinutes()
            : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[4] && unix_stamp < stamp[3]) {
        // 7天内
        var daynames = ["天", "一", "二", "三", "四", "五", "六"];
        var dathStr = "星期" + daynames[_compare_obj.getDay()];

        var SundayText = "星期天";
        var MondayText = "星期一";
        var TuesdayText = "星期二";
        var WednesdayText = "星期三";
        var ThursdayText = "星期四";
        var FridayText = "星期五";
        var SaturdayText = "星期六";

        var dathStr2;

        switch (dathStr) {
          case "星期天":
            dathStr2 = SundayText;
            break;
          case "星期一":
            dathStr2 = MondayText;
            break;
          case "星期二":
            dathStr2 = TuesdayText;
            break;
          case "星期三":
            dathStr2 = WednesdayText;
            break;
          case "星期四":
            dathStr2 = ThursdayText;
            break;
          case "星期五":
            dathStr2 = FridayText;
            break;
          case "星期六":
            dathStr2 = SaturdayText;
            break;
          default:
            dathStr2 = dathStr;
            break;
        }

        return_str =
          dathStr2 +
          " " +
          _compare_obj.getHours() +
          ":" +
          (_compare_obj.getMinutes() < 10
            ? "0" + _compare_obj.getMinutes()
            : _compare_obj.getMinutes());
      } else if (unix_stamp >= stamp[5] && unix_stamp < stamp[4]) {
        // 365天内
        var monthText = "月";
        var dayText = "日";
        return_str =
          _compare_obj.getMonth() -
          -1 +
          monthText +
          _compare_obj.getDate() +
          dayText +
          " " +
          _compare_obj.getHours() +
          ":" +
          (_compare_obj.getMinutes() < 10
            ? "0" + _compare_obj.getMinutes()
            : _compare_obj.getMinutes());
      } else {
        var yearText = "年";
        let monthText = "月";
        let dayText = "日";
        return_str =
          _compare_obj.getFullYear() +
          yearText +
          (_compare_obj.getMonth() - -1) +
          monthText +
          _compare_obj.getDate() +
          dayText +
          " " +
          _compare_obj.getHours() +
          ":" +
          (_compare_obj.getMinutes() < 10
            ? "0" + _compare_obj.getMinutes()
            : _compare_obj.getMinutes());
      }
      return return_str;
      // resolve(return_str);
      // });
    },
    addClass(value, name) {
      this.jobList = [];
      this.liList.filter(item => {
        if (name == item.title) {
          this.status = item.key;
        }
      });
      this.value = Object.assign(
        {},
        { current: 1, size: 10, applyStatus: this.status }
      );
      this.onLoad(this.value);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    jobDetail(id) {
      console.log(id)
      this.$router.push({ path: "jobDetail",query:{id}});
    }
  }
};
</script>

<style lang="less" scoped>
  /deep/.van-tabs__wrap{
    border-bottom: 1px solid #eee;
    padding: 5px 10px;
    margin:10px 0;
    .van-tab--active{
      color:#2E3133;
      background: #EFF1F5;
      border-radius: 50px;

    }
  }
.label-list {
  display: flex;
  align-items: center;
  margin: 16px 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 16px;
  padding-top: 16px;
  li {
    margin-right: 10px;
    padding: 6px 12px;
    color: #989da3;
    height: 24px;
    line-height: 1;
    &.ischeck {
      background: #eff1f5;
      border-radius: 50px;
      color: #444;
    }
  }
}
/deep/ .van-tabs__line {
  width: 0px;
  height: 0px;
}
.r-time {
  text-align: center;
  font-size: 12px;
  color: #989da3;
  padding: 20px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.detail-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  padding-bottom: 14px;
  position: relative;
  padding-right: 14px;
  color: rgb(53 205 216);
  &:after {
    content: "\e603";
    font-size: 12px;
    position: absolute;
    top: 3px;
    right: 0;
    font-family: van-icon;
    color: #a3a7ad;
  }
  .time {
    color: #a3a7ad;
  }

  .top-text {
    font-size: 12px;
    .rejected {
      color: #ff5945;
    }
    .agreed {
      color: #6bcc83;
    }
  }
}
.job-list {
  margin-left: 0;
  margin-right: 0;
  & > li {
    padding: 6px 16px;
    border-bottom: 8px solid #f7f7f7;
    &:last-child {
      border-bottom: 0;
    }
  }
}
.detail-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  span {
    color: #606060;
  }
}
</style>
